export default "__VITE_ASSET__DxvXhpL3__"